import { useContext } from 'react'
import { ViewportContext } from '@contexts'

const useViewport = () => useContext(ViewportContext)

export default useViewport
